/* ==========================================================================
   Crina. Lo que da vida a la ficha: la onda del pelo, la galeria, el selector
   de color y los packs.

   Los packs cambian la CANTIDAD del formulario de Shopify, no el precio: el
   precio lo pone Shopify y no se puede falsear desde el navegador. Si se
   quiere el descuento por pack hay que crearlo como descuento automatico en
   la tienda; mientras no exista, aqui se enseña el total real.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- onda del pelo en la portada ---------- */
  var lienzo = document.querySelector('.hero-onda');
  if (lienzo && lienzo.getContext) {
    var foto = document.querySelector('.hero-img img');
    var cx = lienzo.getContext('2d');
    var BANDA = 4, m = null, visible = true, raf = 0, pendiente = false;
    var X0 = parseFloat(lienzo.dataset.x0 || 0), X1 = parseFloat(lienzo.dataset.x1 || 1);
    var suave = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var empuje = 0, empujeObj = 0, t0 = performance.now();
    var portada = document.querySelector('.hero');

    function medidas() {
      var caja = foto.getBoundingClientRect();
      var dpr = Math.min(devicePixelRatio || 1, 2);
      lienzo.width = Math.round(caja.width * dpr);
      lienzo.height = Math.round(caja.height * dpr);
      lienzo.style.width = caja.width + 'px';
      lienzo.style.height = caja.height + 'px';
      var iw = foto.naturalWidth, ih = foto.naturalHeight;
      if (!iw) return null;
      var esc = Math.max(lienzo.width / iw, lienzo.height / ih);
      var pos = getComputedStyle(foto).objectPosition.split(' ').map(function (v) { return parseFloat(v) / 100; });
      return { iw: iw, ih: ih, dw: iw * esc, dh: ih * esc, esc: esc,
               dx: (lienzo.width - iw * esc) * (isNaN(pos[0]) ? 0.5 : pos[0]),
               dy: (lienzo.height - ih * esc) * (isNaN(pos[1]) ? 0.5 : pos[1]) };
    }
    function amplitud(f) {
      if (f < 0.10 || f > 0.86) return 0;
      var a = Math.min(1, Math.max(0, (f - 0.10) / 0.30));
      var b = Math.min(1, Math.max(0, (0.86 - f) / 0.24));
      var v = a * b; return v * v * (3 - 2 * v);
    }
    function dibuja() {
      pendiente = false;
      if (!m) { m = medidas(); if (!m) return; }
      empuje += (empujeObj - empuje) * 0.08;
      var t = (performance.now() - t0) / 1000, A = 5.5 * m.esc;
      var vaiven = suave ? 0 : 1;
      var sx0 = m.iw * X0, sx1 = m.iw * X1;
      cx.clearRect(0, 0, lienzo.width, lienzo.height);
      for (var y = 0; y < lienzo.height; y += BANDA) {
        var alto = Math.min(BANDA, lienzo.height - y);
        var sy = (y - m.dy) / m.esc, sh = alto / m.esc;
        if (sy < -sh || sy > m.ih) continue;
        var f = (y - m.dy) / m.dh, amp = amplitud(f);
        var onda = vaiven * (Math.sin(t * 0.9 + f * 7.0) + 0.45 * Math.sin(t * 1.7 + f * 3.1));
        var off = amp * (A * onda + empuje * 22 * Math.sin(f * 4.2));
        if (off === 0) { cx.drawImage(foto, 0, sy, m.iw, sh, m.dx, y, m.dw, alto + 0.6); continue; }
        if (sx0 > 0) cx.drawImage(foto, 0, sy, sx0, sh, m.dx, y, sx0 * m.esc, alto + 0.6);
        cx.drawImage(foto, sx0, sy, sx1 - sx0, sh, m.dx + sx0 * m.esc + off, y, (sx1 - sx0) * m.esc, alto + 0.6);
        if (sx1 < m.iw) cx.drawImage(foto, sx1, sy, m.iw - sx1, sh, m.dx + sx1 * m.esc, y, (m.iw - sx1) * m.esc, alto + 0.6);
      }
      if (visible && (!suave || Math.abs(empujeObj - empuje) > 0.002)) raf = requestAnimationFrame(dibuja);
    }
    function avisa() { if (!pendiente) { pendiente = true; cancelAnimationFrame(raf); raf = requestAnimationFrame(dibuja); } }

    var yAnt = scrollY;
    addEventListener('scroll', function () {
      empujeObj = Math.max(-1, Math.min(1, (scrollY - yAnt) / 28)); yAnt = scrollY; avisa();
    }, { passive: true });
    setInterval(function () {
      if (empujeObj !== 0) { empujeObj *= 0.72; if (Math.abs(empujeObj) < 0.01) empujeObj = 0; avisa(); }
    }, 90);

    function arranca() { m = null; lienzo.classList.add('on'); avisa(); }
    if (foto.complete && foto.naturalWidth) arranca();
    else foto.addEventListener('load', arranca, { once: true });
    addEventListener('resize', function () { m = null; avisa(); }, { passive: true });
    if (portada) new IntersectionObserver(function (es) {
      es.forEach(function (e) { visible = e.isIntersecting; if (visible) avisa(); else cancelAnimationFrame(raf); });
    }, { threshold: 0 }).observe(portada);
  }

  /* ---------- el video de portada entra despues del primer pintado ---------- */
  var hv = document.querySelector('.hero-vid');
  if (hv && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var red = navigator.connection || {};
    if (!red.saveData && !/2g/.test(red.effectiveType || '')) {
      addEventListener('load', function () {
        setTimeout(function () {
          hv.preload = 'auto'; hv.load();
          hv.addEventListener('canplay', function () {
            hv.play().then(function () {
              hv.classList.add('listo');
              var c = document.querySelector('.hero-onda'); if (c) c.classList.remove('on');
            }).catch(function () {});
          }, { once: true });
        }, 350);
      });
    }
  }

  /* ---------- reveals al bajar ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0.04 });
  document.querySelectorAll('.r').forEach(function (el) { io.observe(el); });

  /* ---------- videos: solo se cargan al acercarse ---------- */
  var iv = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none' && !v.controls) { v.preload = 'auto'; v.load(); } if (!v.controls) v.play().catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.2 });
  document.querySelectorAll('video:not(.hero-vid)').forEach(function (v) { if (!v.controls) v.muted = true; iv.observe(v); });

  /* Cambiar la foto de un <img> que lleva srcset.
   *
   * Poner solo .src no hace nada: mientras haya srcset, el navegador sigue
   * eligiendo de esa lista y se queda con la de antes. Es el motivo por el
   * que los botones de color parecian muertos aunque el JS se ejecutaba. */
  function ponFoto(im, url) {
    if (!im || !url) return;
    im.removeAttribute('srcset');
    im.removeAttribute('sizes');
    im.src = url;
  }

  /* La miniatura de la foto que ya se esta viendo en grande se esconde.
   *
   * Al entrar en la ficha, el color elegido pone su foto en grande, y esa
   * misma foto seguia estando en el carrete justo debajo: la misma imagen dos
   * veces seguidas. No se puede arreglar en Liquid porque el duplicado lo crea
   * este JavaScript despues de pintar la pagina, no la plantilla.
   *
   * Se compara por el nombre del fichero: la miniatura se pide a 900 px y la
   * grande a 1400, asi que las URL enteras nunca coinciden. */
  function nombreDe(url) {
    return String(url || '').split('?')[0].split('/').pop();
  }
  /* Se le pasa la URL, no se lee del <img>: acabamos de asignarla y el
     navegador todavia devuelve la anterior en currentSrc, asi que leyendola
     se escondia la miniatura equivocada. */
  function escondeRepetida(url) {
    var suyo = nombreDe(url);
    if (!suyo) return;
    document.querySelectorAll('.gal figure:not(.big):not(.fig-vid)').forEach(function (f) {
      var i = f.querySelector('img');
      f.hidden = !!i && nombreDe(i.currentSrc || i.src) === suyo;
    });
  }

  /* ---------- ficha: color, galeria y packs ---------- */
  var grande = document.getElementById('foto-grande');
  var campoVar = document.getElementById('crina-variante');
  var campoCant = document.getElementById('crina-cantidad');
  var precioCta = document.getElementById('cta-precio');
  var precioCab = document.getElementById('precio-cab');

  /* Colores. Con varias opciones (el pack lleva dos) la variante sale de
     cruzar lo elegido en todas ellas, no de un boton suelto. */
  var tabla = document.getElementById('crina-variantes');
  var variantes = [];
  if (tabla) { try { variantes = JSON.parse(tabla.textContent); } catch (e) {} }
  /* Solo los grupos que se eligen: los del pack que van fijos tambien
     llevan .tonos y no deben contar como una opcion. */
  var grupos = [].slice.call(document.querySelectorAll('.tonos[data-opcion]'));
  if (grupos.length && variantes.length) {
    var elegido = grupos.map(function (g) {
      var p = g.querySelector('.tono[aria-pressed="true"]') || g.querySelector('.tono');
      return p ? p.dataset.valor : null;
    });

    function refresca() {
      var v = null;
      for (var i = 0; i < variantes.length; i++) {
        var x = variantes[i], vale = true;
        for (var k = 0; k < elegido.length; k++) { if (x.o[k] !== elegido[k]) { vale = false; break; } }
        if (vale) { v = x; break; }
      }
      if (!v) return;
      if (campoVar) campoVar.value = v.id;
      if (v.img) { ponFoto(grande, v.img); escondeRepetida(v.img); }
      var boton = document.querySelector('.crina-form button[type="submit"]');
      if (boton) {
        boton.disabled = !v.hay;
        if (!v.hay) boton.textContent = 'Agotado en este color';
      }
      /* El precio solo lo toca la variante si no hay un pack elegido: el pack
         cambia la cantidad, y el total ya lo pinta su propio boton. */
      var pack = document.querySelector('#packs .pack[aria-pressed="true"]');
      if (!pack && v.hay) {
        if (precioCta) precioCta.textContent = v.p;
        if (precioCab) precioCab.textContent = v.p;
      }
    }

    grupos.forEach(function (g, n) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.tono');
        if (!b || !g.contains(b)) return;
        g.querySelectorAll('.tono').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        elegido[n] = b.dataset.valor;
        /* En el pack la variante no tiene foto: la trae el propio boton */
        ponFoto(grande, b.dataset.img);
        escondeRepetida(b.dataset.img);
        var eti = g.parentElement.querySelector('.tono-nombre');
        if (eti) eti.textContent = b.dataset.valor;
        refresca();
      });
    });
    refresca();
  }

  document.querySelectorAll('.gal figure:not(.big):not(.fig-vid) img').forEach(function (im) {
    im.parentElement.classList.add('pinchable');
    im.parentElement.addEventListener('click', function () {
      if (!grande) return;
      var antes = grande.currentSrc || grande.src, alt = grande.getAttribute('alt');
      var suya = im.currentSrc || im.src;
      ponFoto(grande, suya);
      grande.setAttribute('alt', im.getAttribute('alt') || '');
      ponFoto(im, antes); im.setAttribute('alt', alt || '');
      escondeRepetida(suya);
    });
  });

  document.querySelectorAll('#packs .pack').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('#packs .pack').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      if (campoCant) campoCant.value = b.dataset.u;
      if (precioCta) precioCta.textContent = b.dataset.p;
      if (precioCab) precioCab.textContent = b.dataset.p;
    });
  });

  /* ---------- añadir a la cesta sin salir de la ficha ----------
     El formulario de Shopify manda a /cart y te saca de la pagina. Aqui se
     manda por detras a /cart/add.js, se actualiza el contador de la cabecera
     y se avisa con un aviso arriba. Si el JS falla, el formulario sigue
     enviandose como siempre: no se rompe la compra. */
  var formu = document.getElementById('crina-form');
  if (formu && window.fetch) {
    var aviso = null, tempo = 0;
    function saluda(txt, url) {
      if (!aviso) {
        aviso = document.createElement('div');
        aviso.className = 'aviso-cesta';
        aviso.setAttribute('role', 'status');
        document.body.appendChild(aviso);
      }
      aviso.innerHTML = '';
      var t = document.createElement('span'); t.textContent = txt; aviso.appendChild(t);
      if (url) {
        var a = document.createElement('a'); a.href = url; a.textContent = 'Ver la cesta';
        aviso.appendChild(a);
      }
      requestAnimationFrame(function () { aviso.classList.add('on'); });
      clearTimeout(tempo);
      tempo = setTimeout(function () { aviso.classList.remove('on'); }, 5000);
    }

    formu.addEventListener('submit', function (e) {
      e.preventDefault();
      var boton = formu.querySelector('button[type="submit"]');
      var antes = boton ? boton.textContent : '';
      if (boton) { boton.disabled = true; boton.textContent = 'Añadiendo...'; }
      fetch('/cart/add.js', {
        method: 'POST', body: new FormData(formu),
        headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
      }).then(function (r) {
        if (!r.ok) throw new Error('no');
        return r.json();
      }).then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      }).then(function (c) {
        var cnt = document.querySelector('.rt .cnt');
        if (cnt) { cnt.textContent = c.item_count; cnt.classList.add('hay'); }
        saluda('Añadido a la cesta.', '/cart');
      }).catch(function () {
        formu.submit();          /* si algo falla, al metodo de siempre */
      }).then(function () {
        if (boton) { boton.disabled = false; boton.textContent = antes; }
      });
    });
  }

  /* ── LA FOTO DE UNA RESEÑA, AMPLIADA ──────────────────────────────────────
   *
   * Las miniaturas van pequeñas a propósito: la reseña es el texto y la foto
   * es la prueba, no al revés. Pero una foto de 90 px no se ve, así que al
   * pulsarla se abre entera.
   *
   * Se usa <dialog> nativo, que ya trae el cierre con Escape, el foco atrapado
   * dentro y el fondo inerte. Escribir eso a mano es cómo se cuelan los fallos
   * de accesibilidad.
   *
   * Y la ampliada va con object-fit:contain, no cover: aquí sí importa ver la
   * foto entera y sin recortar. */
  var resenas = document.querySelector('.res');
  if (resenas && window.HTMLDialogElement) {
    var caja = document.createElement('dialog');
    caja.className = 'res-lupa';
    caja.innerHTML = '<button type="button" aria-label="Cerrar">&times;</button><img alt="">';
    document.body.appendChild(caja);
    var ampliada = caja.querySelector('img');

    resenas.addEventListener('click', function (e) {
      var b = e.target.closest('.res-fotos button');
      if (!b) return;
      var im = b.querySelector('img');
      /* La miniatura es de 260 px: abrirla ampliada seria enseñar la misma
         foto borrosa. La grande va aparte, en data-grande. */
      ampliada.src = b.getAttribute('data-grande') || im.src;
      ampliada.alt = im.alt;
      caja.showModal();
    });
    caja.addEventListener('click', function (e) {
      /* Pulsar fuera de la imagen cierra: es lo que todo el mundo intenta. */
      if (e.target === caja || e.target.tagName === 'BUTTON') caja.close();
    });
    caja.addEventListener('close', function () { ampliada.removeAttribute('src'); });
  }

})();
